import { Injectable, signal } from '@angular/core';
import { NotificationDto } from './notification-api.service';
import { PostDto } from '@/helper/dto/cmp/post.dto';
import { LabelDto } from '@/helper/dto/cmp/label.dto';

export interface NotificationToastView {
    toastId: string;
    notification: NotificationDto;
    post?: PostDto | null;
    labels?: LabelDto[];
}

const DEFAULT_LIFE_MS = 8000;

@Injectable({ providedIn: 'root' })
export class NotificationToastService {
    readonly toasts = signal<NotificationToastView[]>([]);

    private seq = 0;
    private timers = new Map<string, ReturnType<typeof setTimeout>>();

    show(view: Omit<NotificationToastView, 'toastId'> & { toastId?: string }, lifeMs = DEFAULT_LIFE_MS): void {
        const toastId = view.toastId ?? `nt-${++this.seq}`;
        this.toasts.update((list) => [...list, { ...view, toastId }]);
        this.scheduleDismiss(toastId, lifeMs);
    }

    dismiss(toastId: string): void {
        const timer = this.timers.get(toastId);
        if (timer) clearTimeout(timer);
        this.timers.delete(toastId);
        this.toasts.update((list) => list.filter((item) => item.toastId !== toastId));
    }

    private scheduleDismiss(toastId: string, lifeMs: number): void {
        const existing = this.timers.get(toastId);
        if (existing) clearTimeout(existing);
        const timer = setTimeout(() => this.dismiss(toastId), lifeMs);
        this.timers.set(toastId, timer);
    }
}
